import { createFilledIcon } from "../createIcon";

export const CheckCircleFilledIcon = createFilledIcon(
  <>
    <path d="M2.4 12a9.6 9.6 0 1 1 19.2 0 9.6 9.6 0 0 1-19.2 0Zm14.649-1.552a1.2 1.2 0 0 0-1.697-1.697L10.8 13.303 9.25 11.75a1.2 1.2 0 1 0-1.697 1.697l2.4 2.4a1.2 1.2 0 0 0 1.697 0l5.4-5.4Z" />
  </>,
  "CheckCircleFilledIcon"
);
